import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import {
    PersonOutlineOutlinedIcon,
    LinkOutlinedIcon,
    FilterAltOutlinedIcon,
    EmailOutlinedIcon,
    QrCodeOutlinedIcon,
    VideocamOutlinedIcon,
    DriveFileRenameOutlineOutlinedIcon,
    ShoppingBagOutlinedIcon,
    LockOutlinedIcon,
    EventIcon,
    BusinessIcon,
    DevicesIcon
} from 'icons/materialIcons';
import { useLocation } from 'react-router-dom';

const TeamV2MemberEditSidenav = ({ onMenuItemClick, selectedItem, restrictedMode = false, hideOtherSections = false }) => {
    const location = useLocation();
    const isNewMember = location.pathname.includes('add-member');

    const listItemStyle = {
        padding: '4px 8px',
        whiteSpace: 'nowrap',
        minHeight: '40px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
    };

    const selectedItemStyle = {
        ...listItemStyle,
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        borderLeft: '3px solid #000'
    };

    const listItemTextStyle = {
        margin: 0,
        '& .MuiTypography-root': {
            fontSize: '0.8rem',
            fontWeight: 600,
            color: "#4f4f4f",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    };

    const selectedTextStyle = {
        ...listItemTextStyle,
        '& .MuiTypography-root': {
            ...listItemTextStyle['& .MuiTypography-root'],
            color: '#000',
            fontWeight: 700
        }
    };

    const iconStyle = {
        minWidth: '32px',
        marginRight: 0.5
    };

    const selectedIconStyle = {
        ...iconStyle,
        color: '#000'
    };

    return (
        <Box
            sx={{
                display: { xs: 'none', sm: 'block' },
                backgroundColor: '#ffffff',
                borderRadius: '8px 0 0 8px',
            }}
        >
            <Box sx={{ marginTop: 2 }}>
                {/* Menu Items with more spacing */}
                <List sx={{ '& .MuiListItem-root': { ...listItemStyle, marginBottom: 1 } }}>
                    <ListItem
                        onClick={() => onMenuItemClick('content')}
                        sx={selectedItem === 'content' ? selectedItemStyle : listItemStyle}
                    >
                        <ListItemIcon sx={selectedItem === 'content' ? selectedIconStyle : iconStyle}>
                            <PersonOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Content"
                            sx={selectedItem === 'content' ? selectedTextStyle : listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem
                        onClick={() => onMenuItemClick('about')}
                        sx={selectedItem === 'about' ? selectedItemStyle : listItemStyle}
                    >
                        <ListItemIcon sx={selectedItem === 'about' ? selectedIconStyle : iconStyle}>
                            <PersonOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="About"
                            sx={selectedItem === 'about' ? selectedTextStyle : listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem
                        onClick={() => onMenuItemClick('touchCode')}
                        sx={selectedItem === 'touchCode' ? selectedItemStyle : listItemStyle}
                    >
                        <ListItemIcon sx={selectedItem === 'touchCode' ? selectedIconStyle : iconStyle}>
                            <QrCodeOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="TouchCode"
                            sx={selectedItem === 'touchCode' ? selectedTextStyle : listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem
                        onClick={() => onMenuItemClick('leadCapture')}
                        sx={selectedItem === 'leadCapture' ? selectedItemStyle : listItemStyle}
                    >
                        <ListItemIcon sx={selectedItem === 'leadCapture' ? selectedIconStyle : iconStyle}>
                            <FilterAltOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Lead Capture"
                            sx={selectedItem === 'leadCapture' ? selectedTextStyle : listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem
                        onClick={() => onMenuItemClick('virtualBackground')}
                        sx={selectedItem === 'virtualBackground' ? selectedItemStyle : listItemStyle}
                    >
                        <ListItemIcon sx={selectedItem === 'virtualBackground' ? selectedIconStyle : iconStyle}>
                            <VideocamOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Virtual Background"
                            sx={selectedItem === 'virtualBackground' ? selectedTextStyle : listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem
                        onClick={() => onMenuItemClick('emailSignature')}
                        sx={selectedItem === 'emailSignature' ? selectedItemStyle : listItemStyle}
                    >
                        <ListItemIcon sx={selectedItem === 'emailSignature' ? selectedIconStyle : iconStyle}>
                            <DriveFileRenameOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Email Signatures"
                            sx={selectedItem === 'emailSignature' ? selectedTextStyle : listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem
                        onClick={() => onMenuItemClick('devices')}
                        sx={selectedItem === 'devices' ? selectedItemStyle : listItemStyle}
                    >
                        <ListItemIcon sx={selectedItem === 'devices' ? selectedIconStyle : iconStyle}>
                            <DevicesIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Add Touch Devices"
                            sx={selectedItem === 'devices' ? selectedTextStyle : listItemTextStyle}
                        />
                    </ListItem>
                </List>
            </Box>
        </Box>
    );
};

export default TeamV2MemberEditSidenav;
